// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/validate-address-request-schema',
  type: 'object',
  required: [],
  properties: {
    countryIso2: {
      type: 'string',
    },
    street: {
      type: 'string',
    },
    houseNumber: {
      type: 'string',
    },
    postalCode: {
      type: 'string',
    },
    postalCodeAddition: {
      type: 'string',
    },
    city: {
      type: 'string',
    },
    limit: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
